// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"css/base/colors.css\"","main-color":"var(--main-color)","grey-xlight":"#fcfcfc","container":"_3mBzoP_ _1ZWPIqK","application_content":"_3tbAcOa","controls":"_1wm0rgU"};